export default __webpack_public_path__ + "static/media/18.63793776.jpg";